import _md5 from 'md5'
import { strings } from 'context/LanguageContext/strings'
import { isEmpty } from './appUtils'
import dayjs from 'dayjs'
import moment from "moment";
import constants from './constants';

const Util = {
    getReqHash(e, req) {
        if (req && e && req.password) {
            let reqHash = ''
            const combinationHash = _md5(e) + _md5(req.password)
            const salt = combinationHash.split('')
            salt.forEach(s => {
                reqHash = _md5(s + combinationHash + req.hk)
            })
            return reqHash
        } else {
            return null
        }
    },
    debounce() {
        let instanceID = ''
        return function (callback, dTime = 300) {
            if (instanceID) {
                clearTimeout(instanceID)
            }
            instanceID = setTimeout(callback, dTime)
        }
    },
    calculateDistance(pointA, pointB) {
        // http://www.movable-type.co.uk/scripts/latlong.html
        const lat1 = pointA.coordinate.latitude
        const lon1 = pointA.coordinate.longitude

        const lat2 = pointB.coordinate.latitude
        const lon2 = pointB.coordinate.longitude

        const R = 6371e3 // earth radius in meters
        const φ1 = lat1 * (Math.PI / 180)
        const φ2 = lat2 * (Math.PI / 180)
        const Δφ = (lat2 - lat1) * (Math.PI / 180)
        const Δλ = (lon2 - lon1) * (Math.PI / 180)

        const a =
            Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) * (Math.sin(Δλ / 2) * Math.sin(Δλ / 2))

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

        const distance = R * c // distance is in meters

        return Math.floor(distance * 0.000621371192) // convert from meters to miles and take the floor value
    },
    isAddressValid(address) {
        return !isEmpty(address) &&
            !isEmpty(address.zip) &&
            !isEmpty(address.street) &&
            !address?.street?.includes('undefined') &&
            !isEmpty(address.city)
            ? true
            : false
    },
    ObjectSize(obj) {
        let size = 0,
            key
        for (key in obj) {
            if (obj.hasOwnProperty(key)) size++
        }
        return size
    },
    getFormattedString(obj, key) {
        return parseFloat(obj[key]) + strings[`${obj[key].replace(/[\d.]/g, '').trim()}`]
    },
    getEmailValidationRegEx(){
        return new RegExp('^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\\.)+[A-Z]{2,64}$', 'i');
    },
    getValidDateandTime(storeOperational,minLeadTime,maxLeadTime) {
        // Fallbacks for lead time
        const leadMin = typeof minLeadTime === 'number' && minLeadTime > 0 ? minLeadTime : constants.minLeadTime;
        const leadMax = typeof maxLeadTime === 'number' && maxLeadTime > 0 ? maxLeadTime : constants.maxLeadTime;

        // Make sure we use the provided storeOperational data and not the fallback if it exists
        const validDateTime = isEmpty(storeOperational) ? constants.fallBackStoreOperational : storeOperational;
        
        // Ensure workingDays is properly extracted from the API response
        const workingDays = validDateTime?.workingDays || [];
        
        const openTime = dayjs(validDateTime?.workingHours.from, 'H:mm');
        const closeTime = dayjs(validDateTime?.workingHours.to, 'H:mm');

        const startDate = dayjs().add(leadMin, 'day').startOf('day');
        let validDates = [];
        let date = startDate.clone();
        
        // Generate valid dates within the lead time range
        // Only include dates where the day of week is in the workingDays array
        let daysChecked = 0;
        while (validDates.length < leadMax && daysChecked < leadMax * 2) {
            const dayOfWeek = date.format('ddd');
            
            // Check if the day is in the workingDays array
            const isWorkingDay = workingDays.indexOf(dayOfWeek) !== -1;
            
            if (isWorkingDay) {
                validDates.push(date.clone());
            }
            date = date.add(1, 'day');
            daysChecked++;
        }

        function isValidWorkingDate(dateToCheck) {
            if (!dateToCheck) return false;
            
            // First check if the day of week is in workingDays
            const dayOfWeek = dateToCheck.format('ddd');
            
            // Use indexOf instead of includes for more reliable checking
            const isWorkingDay = workingDays.indexOf(dayOfWeek) !== -1;
            
            // If it's not a working day (e.g., Sunday), return false immediately
            if (!isWorkingDay) {
                return false;
            }
            
            // Then check if it's in our valid dates range
            return true;
        }

        function isValidWorkingTime(value, type, currentDate) {
            if (!isValidWorkingDate(currentDate)) return true; // disable if date invalid

            if (type === 'hours') {
                const hour24 = dayjs(value).hour();
                return hour24 < openTime.hour() || hour24 > closeTime.hour();
            }

            if (type === 'minutes') {
                const selectedHour = currentDate.hour();
                const minuteValue = dayjs(value).minute();

                if (selectedHour === openTime.hour()) {
                    return minuteValue < openTime.minute();
                }
                if (selectedHour === closeTime.hour()) {
                    return minuteValue > closeTime.minute();
                }
                return false;
            }
            return false;
        }        
        return { isValidWorkingDate, isValidWorkingTime };
    },
    parseWorkingHour(hhmm) {
        const match = String(hhmm || '').match(/(\d{1,2}):(\d{2})/);
        if (!match) return { h: 0, m: 0 };
        return { h: parseInt(match[1], 10), m: parseInt(match[2], 10) };
    },
    checkForMixedCartTypeItems(items,product) {
        const isProuctPlatter = product?.platter_item_flag === '1'
        const itemsAddedToCart = items?.filter(item=>item?.platter_item_flag === '1')
        const preOrderItemsCount = itemsAddedToCart?.length
        const cartItemsCount = items?.length
        if(items?.length > 0 && preOrderItemsCount > 0 && !product && (preOrderItemsCount !== cartItemsCount)){
            return true
        }
        const isItemsAddedToCartPlatter = preOrderItemsCount > 0       
        if(items.length > 0 && product){
            return !(isProuctPlatter === isItemsAddedToCartPlatter)
        }
        return false

    },
    checkForPreOrderItems(items){
        if(!items?.length) return false
        return items.every(item => item?.platter_item_flag === '1')
    },
    hasLeadTimePassed(order, preOrderMinLeadTime) {
        if (!order?.scheduledPickupDate) return false;

        const storeTZ = order?.store_details?.time_zone || constants.DEFAULT_TIMEZONE;
        const minLeadTime = preOrderMinLeadTime || constants.minLeadTime;
        // pickup date in store timezone
        const pickup = moment.tz(order.scheduledPickupDate, storeTZ);

        // start of pickup day
        const pickupStart = pickup.clone().startOf("day");

        // subtract lead days (these must be full days before pickup)
        const leadStart = pickupStart.clone().subtract(minLeadTime, "days");

        // last cancel time = previous day 23:59:00
        const cancelDeadline = leadStart.clone()
            .subtract(1, "day")
            .set({
                hour: 23,
                minute: 59,
                second: 0,
                millisecond: 0
            });

        const now = moment.tz(storeTZ);

        return now.isAfter(cancelDeadline);
    }
}

export default Util
